import React, { useEffect } from "react";
import Nav from "./2-modules/Nav";
import { connect } from "react-redux";
import { fetchBlogs, doUpdateUrl } from "./4-redux/actions";
import Router from "./Router";

function App({ fetchBlogs, doUpdateUrl }) {
  // fetches blogs on mount
  useEffect(() => {
    fetchBlogs().then(() => doUpdateUrl(window.location.pathname));
  }, []);

  return (
    <div>
      <Nav />
      <Router />
    </div>
  );
}

const actions = { fetchBlogs, doUpdateUrl };

export default connect(
  null,
  actions
)(App);
